import React, { Component } from 'react';
import { authProvider } from '../authProvider';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import CodeEditor from '@uiw/react-textarea-code-editor';
import { Button, ButtonGroup, Container, Col, Row, Table, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
const currencyFormatParams = {
    displayType: 'text',
    decimalScale: 2,
    fixedDecimalScale: true,
    thousandSeparator: true,
    prefix: '$'
};

export class CostingEditor extends Component {
    constructor(props) {
        super(props);
        var rootUrl = window.location.protocol + '//' + window.location.host + '/';
        this.state = ({ rootUrl: rootUrl, token: null, isAuthorized: false, headers: {}, definitions: [] });
        this.componentDidMount = this.componentDidMount.bind(this);
        this.getDefinitions = this.getDefinitions.bind(this);
        this.fieldChange = this.fieldChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onRevert = this.onRevert.bind(this);
        this.replaceDef = this.replaceDef.bind(this);
    }
    componentDidMount() {
        var self = this;

        authProvider.getAccessToken().then(function (result) {
            console.log(result);
            var tkn = result.accessToken;

            if (tkn) {

                self.setState({ token: tkn, isAuthorized: true, headers: { 'Authorization': "Bearer " + tkn } });
                self.getDefinitions();
            }
            else {
                console.log("Token not acquired!")
            }
        })
    }
    render() {
        var result = "";
        const defs = this.state.definitions;
        if (defs == null || defs.length < 1) {
            result = <div><h2>Loading...</h2></div>;
        }
        else {
            result = <div>
                {defs.map((val, ind) =>
                    <div className="definitionPanel" key={val.id} >
                        <Form>
                            <FormGroup disabled>
                                <Label for={"configName" + val.id}>Config Name</Label>
                                <Input type="text" name="ConfigName" id={"configName" + val.id} value={val.configName} disabled />
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" name="ntCostIsCalculated" id={"isNtCostCalc" + val.id} checked={val.ntCostIsCalculated} onChange={this.fieldChange(val)} />
                                    NT Cost is Calculated
                                </Label>

                            </FormGroup>
                            {val.ntCostIsCalculated &&
                                <FormGroup>
                                    <Label for={"ntCostFormula" + val.id}>Formula</Label>
                                    <Input type="textarea" name="ntCostFormula" id={"ntCostFormula" + val.id} value={val.ntCostFormula || ''} onChange={this.fieldChange(val)} />
                                </FormGroup>
                            }
                            {(!val.ntCostIsCalculated) &&
                                <FormGroup>
                                    <Label for={"ntCost" + val.id}>Cost</Label>
                                    <Input type="number" steps="0.01" name="ntCost" id={"ntCost" + val.id} value={val.ntCost || ''} onChange={this.fieldChange(val)} />
                                </FormGroup>
                            }
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" name="costIsCalculated" id={"isCostCalc" + val.id} checked={val.costIsCalculated} onChange={this.fieldChange(val)} />
                                    Cost is Calculated
                                </Label>

                            </FormGroup>
                            {val.costIsCalculated &&
                                <FormGroup>
                                <Label for={"costFormula" + val.id}>Formula</Label>
                                <CodeEditor
                                    id={"costFormula" + val.id}
                                    value={val.costFormula || ''}
                                    language="python"
                                    placeholder="Please enter python code."
                                    padding={15}
                                    style={{
                                        fontSize: 12,
                                        backgroundColor: "#f5f5f5",
                                        fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                                    }}
                                    onChange={this.fieldChange(val)}
                                />
                                    {/*<Input type="textarea" name="costFormula" id={"costFormula" + val.id} value={val.costFormula || ''} onChange={this.fieldChange(val)} />*/}
                                </FormGroup>
                            }
                            {(!val.costIsCalculated) &&
                                <FormGroup>
                                    <Label for={"cost" + val.id}>Cost</Label>
                                    <Input type="number" steps="0.01" name="cost" id={"cost" + val.id} value={val.cost || ''} onChange={this.fieldChange(val)} />
                                </FormGroup>
                            }
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" name="priceIsCalculated" id={"isPriceCalc" + val.id} checked={val.priceIsCalculated || ''} onChange={this.fieldChange(val)} />
                                    Price is Calculated
                                </Label>

                            </FormGroup>
                            {val.priceIsCalculated &&
                                <FormGroup>
                                <Label for={"priceFormula" + val.id}>Formula</Label>
                                <CodeEditor
                                    id={"priceFormula" + val.id}
                                    value={val.priceFormula || ''}
                                    language="python"
                                    placeholder="Please enter python code."
                                    padding={15}
                                    style={{
                                        fontSize: 12,
                                        backgroundColor: "#f5f5f5",
                                        fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                                    }}
                                    onChange={this.fieldChange(val)}
                                />
                                    {/*<Input type="textarea" name="priceFormula" id={"priceFormula" + val.id} value={val.priceFormula || ''} onChange={this.fieldChange(val)} />*/}
                                </FormGroup>
                            }
                            {(!val.priceIsCalculated) &&
                                <FormGroup>
                                    <Label for={"price" + val.id}>Price</Label>
                                    <Input type="number" steps="0.01" name="price" id={"price" + val.id} value={val.price || ''} onChange={this.fieldChange(val)} />
                                </FormGroup>
                            }
                            <ButtonGroup>
                                <Button color="primary" onClick={() => { this.onSave(val); }}>Save</Button>
                                <Button color="secondary" onClick={() => { this.onRevert(val); }}>Revert</Button>
                            </ButtonGroup>
                        </Form>
                        <hr />
                    </div>
                )}
            </div>;
        }
        return result;
    }

    replaceDef(oDef, nDef) {
        return this.state.definitions.map(def => def.id === oDef.id ? nDef : def);
    }
    getDefinitions() {
        // load the costing definitions here
        axios.get(this.state.rootUrl + "CostingConfig", { headers: this.state.headers }).then(res => {
            this.setState({ definitions: res.data });
        });
    }
    onSave(def) {
        axios.post(this.state.rootUrl + 'CostingConfig', def, { headers: this.state.headers }).then(res => {
            var savedDef = res.data;
            if (savedDef) {
                var defs = this.replaceDef(def, savedDef);
                this.setState({ definitions: defs });
            }

            if(this.props.onUpdated){
                this.props.onUpdated();
            }

        });

    }
    onRevert(def) {
        axios.get(this.state.rootUrl + "CostingConfig/" + def.id, { headers: this.state.headers }).then(res => {
            var item = res.data;
            if (!item)
                return;
            var defs = this.replaceDef(def, item);

            this.setState({ definitions: defs });
        });
    }
    fieldChange(def) {
        var self = this;
        return (evt) => {
            var value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
            if (value === '') {
                value = null;
            }
            const name = evt.target.name;
            var defs = self.state.definitions;
            if (defs) {
                // get matching def from defs
                var matches = defs.filter(item => item.id === def.id);
                if (matches.length < 1)
                    return;
                var item = matches[0];

                // modify def from defs
                item[name] = value;
                // set state with defs
                self.setState(defs);
            }
        };
    }

}